import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import Minisoimg from "./minisobw.jpg";
import Lontorbw from "./lontorbw.jpg";
import Greebw from "./greebw.jpg";
import Palert from "./palert.jpg";
import Goldsoul from "./goldsoul.jpg";
import Ebonyigov from "./ebonyigov.jpg";
import Multichoice from "./multichoice.jpg";
import Moreplex from "./moreplextv.jpg";

function Brandlogos() {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);
  return (
    <div className='brand-bg1'>
      <div
        className='d-flex flex-column flex-center w-100 min-h-350px min-h-lg-500px px-9'
        data-aos='fade-up'
      >
        <div className='text-center mb-5 mb-lg-10 py-3 py-lg-8'>
          <h1 className='text-white lh-base fw-bolder fs-2x fs-lg-3x mb-4'>
            Brands That Trust Our Outstanding <br />
            Solution
          </h1>
        </div>

        <div className='d-flex flex-center flex-wrap position-relative px-5'>
          <div className='d-flex flex-center m-3 m-md-6'>
            <img img src={Minisoimg} className='mh-70px mh-lg-80px' alt='' />
          </div>

          <div className='d-flex flex-center m-3 m-md-6'>
            <img src={Lontorbw} className='mh-70px mh-lg-80px' alt='' />
          </div>

          <div className='d-flex flex-center m-3 m-md-6'>
            <img src={Greebw} className='mh-70px mh-lg-80px' alt='' />
          </div>

          <div className='d-flex flex-center m-3 m-md-6'>
            <img img src={Goldsoul} className='mh-70px mh-lg-80px' alt='' />
          </div>

          <div className='d-flex flex-center m-3 m-md-6'>
            <img src={Palert} className='mh-70px mh-lg-80px' alt='' />
          </div>
          <div className='d-flex flex-center m-3 m-md-6'>
            <img src={Ebonyigov} className='mh-70px mh-lg-80px' alt='' />
          </div>
          <div className='d-flex flex-center m-3 m-md-6'>
            <img src={Multichoice} className='mh-70px mh-lg-80px' alt='' />
          </div>
          <div className='d-flex flex-center m-3 m-md-6'>
            <img src={Moreplex} className='mh-70px mh-lg-80px' alt='' />
          </div>

          {/* <div
            className='d-flex flex-center m-3 m-md-6'
            data-bs-toggle='tooltip'
            title=''
            data-bs-original-title='AON - Empower Results'
          >
            <img
              src='assets/media/svg/brand-logos/aon.svg'
              className='mh-30px mh-lg-40px'
              alt=''
            />
          </div> */}
          {/* 
          <div
            className='d-flex flex-center m-3 m-md-6'
            data-bs-toggle='tooltip'
            title=''
            data-bs-original-title='Hewlett-Packard'
          >
            <img
              src='assets/media/svg/brand-logos/hp-3.svg'
              className='mh-30px mh-lg-40px'
              alt=''
            />
          </div> */}
          {/* 
          <div
            className='d-flex flex-center m-3 m-md-6'
            data-bs-toggle='tooltip'
            title=''
            data-bs-original-title='Truman'
          >
            <img
              src='assets/media/svg/brand-logos/truman.svg'
              className='mh-30px mh-lg-40px'
              alt=''
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Brandlogos;
